export default "https://cdn-web.disco.co/write_with_ai-58e78b06c131ff26e96885b139932738.png";